module.exports = __webpack_public_path__ + "media/images/news/whatsapp-web-5915bf12c70c3cd742f2cfb68654229d.png";